import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import SplitViewFieldsGrid from '../../../../components/generic/SplitViewFieldsGrid';

const ExternalAuditDetailsTab = ({
  selectedRecord,
  config,
  fields,
}) => {
  const { theme } = useTheme();

  if (!selectedRecord) {
    return (
      <div className={cn('p-4 text-center', theme.text.muted)}>
        No record selected
      </div>
    );
  }

  return (
    <div
      className="p-4 flex-1 overflow-y-auto advanced-table-scroll"
      style={{
        scrollbarWidth: 'thin',
        minHeight: 0,
        maxHeight: '100%',
      }}
    >
      <div className="grid grid-cols-1 gap-4">
        <SplitViewFieldsGrid
          selectedRecord={selectedRecord}
          fields={fields}
          config={config}
          layout="boxed"
        />
      </div>
    </div>
  );
};

export default ExternalAuditDetailsTab;
